
import { Get_Home_Page } from "../../api/global/Global";
import {
  FETCH_HOME_DATA_REQUEST,
  FETCH_HOME_DATA_SUCCESS,
  FETCH_HOME_DATA_FAILURE
} from "../types"

export const fetchHomeData = () => async (dispatch, getState) => {
 const { homedata } = getState();
  const { status } = homedata;

  if (status === "pending") {
    return;
  }

   if (status === "success") {
    return;
  }

 

  dispatch({ type: FETCH_HOME_DATA_REQUEST });
  try {
    const response = await Get_Home_Page();    

    if (response?.data?.status == 200) {
      dispatch({
        type: FETCH_HOME_DATA_SUCCESS,
        payload: response?.data?.data,
      });
    } else {
      dispatch({
        type: FETCH_HOME_DATA_FAILURE,
        payload: "Failed to fetch setting data",
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_HOME_DATA_FAILURE,
      payload: error.message,
    });
  }
};